<template>
  <div class="delete-icon-box">
    <i class="UXicon-error delete-icon" @click.stop="() => { toggleIsRemoveItem(item) }"></i>
  </div>
</template>

<script>
export default {
  name: 'removeIcon',
  props: {
    item: Object
  },
  methods: {
    toggleIsRemoveItem (item) {
      this.$eventBus.$emit('change-is-remove-item', item.id, item.type, true)
    }
  }
}
</script>

<style scoped lang="scss">
  .delete-icon-box {
    display: flex;
    justify-content: flex-end;
    flex: 0 1 auto;
  }

  .delete-icon {
    color: #FF7875;

    &:before {
      display: flex;
      flex: 1 1 auto;
      justify-content: flex-end;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/agent/components/removeIcon.vue